import { render, staticRenderFns } from "./ProcesoTabAplicacion.vue?vue&type=template&id=b703685e&"
import script from "./ProcesoTabAplicacion.vue?vue&type=script&lang=js&"
export * from "./ProcesoTabAplicacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports